import './instrument';
import './index.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { UserContextProvider } from './contexts/userContext';

const root = document.getElementById('root') as HTMLElement;

if (root) {
    ReactDOM.createRoot(root).render(
        <React.StrictMode>
            <BrowserRouter>
                <UserContextProvider>
                    <App />
                </UserContextProvider>
            </BrowserRouter>
        </React.StrictMode>
    );
}
